module.exports = __webpack_public_path__ + "static/img/chanta (5).d0419fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (5).jpg
// module id = b/QS
// module chunks = 0